var a="Woa",f="#417ff9";export{a as COMPONENTS_NAME_PREFIX,f as DEFAULT_THEME_COLOR};
